import type { DealerContextProps } from "@porsche-customer/slfinrtl-context-types"
import { useContext } from "react"
import { DealerContext } from "./DealerContext"

export const useDealerContext = (): DealerContextProps => {
	const value = useContext(DealerContext)
	if (value === undefined) {
		throw Error("You are trying to access DealerContext but it is not defined yet.")
	}

	return value
}
